import React from "react";
import OrderTable from "../Table";

const OutForDelivery = () => {
  return <OrderTable type="Out for Delivery" />;
};

export default OutForDelivery;
